<template>
  <div class="personal-overview" ref="personal-overview" v-loading="loading">
    <Table :dataset="dataset.unArch"  v-if="dataset.unArch.length > 0" @load="load" :isLoading="isLoading" :isFinish="isFinish" @openTask="openTask"></Table>
    <Gantt :dataset="dataset" v-if="dataset.unArch.length > 0"></Gantt>
    <nothing v-if="!loading && dataset.unArch.length === 0"></nothing>
  </div>
</template>
<script>
import Table from './table'
import api from '@/services/api/mine/mine'
import Gantt from '@/views/task/taskSuper/ganttNew/main'
import bus from '@/bus'
import { mapState, mapMutations } from 'vuex'
export default {
  props: ['uid', 'onlyReal'],
  components: {
    Table,
    Gantt
  },
  computed: {
    ...mapState('mine/mine', {
      queryMsg: state => state.queryMsg
    })
  },
  data() {
    let _this = this
    return {
      loading: true,
      isLoading: false,
      isFinish: false,
      dataset: {
        unArchClose: false,
        archClose: false,
        unArch:[],
        arch: [],
      },
      pageData: {
        page: 0,
        number: 20,
        sort_rule: 'due_date_sort',
        uid: _this.uid
      },
    }
  },
  watch: {
    queryMsg: {
      handler() {
        this.pageData.keyword = this.queryMsg.keyword
        this.pageData.my_execution = this.queryMsg.my_execution
        this.pageData.project_id = this.queryMsg.project_id
        this.pageData.sort_rule = this.queryMsg.sort_rule
        this.init()
      },
      deep: true,
    }
  },
  mounted() {
    this.windowAddMouseWheel()
    this.init()
    bus.$on('updateTask', (data) => {
      this.init()
    })
  },
  destroyed() {
     bus.$off('updateTask')
  },
  methods: {
    ...mapMutations('task/task', ['CHANGE_TASK']),
    openTask(item) {
      this.CHANGE_TASK({ visible: true, task_id: item.id })
    },
    async init() {
      this.pageData.page = 0
      this.isFinish = false
      this.loading = true
      this.dataset.unArch = []
      await this.load()
      this.loading = false
    },
    async load() {
      if(this.isFinish) return
      this.isLoading = true
      this.pageData.page = this.pageData.page + 1
      let result = await api[this.queryMsg.status_filter]({ ...this.pageData })
      this.dataset.unArch.push(...result.data)
      if (this.dataset.unArch.length === 0 && result.data.length < this.pageData.number) {
        this.dataset.unArch = []
        this.isFinish = true
      } else if (result.data.length < this.pageData.number) {
        this.isFinish = true
      }
      this.isLoading = false
    },
    windowAddMouseWheel() {
      var scrollFunc = (e) => {
        e = e || window.event;
        e.preventDefault();
        e.stopPropagation();
        let value = ''
        let n = -1
        if (e.wheelDelta) {  //判断浏览器IE，谷歌滑轮事件
          value = e.wheelDelta
          value > 0 ? n = -1 : n = 1
        } else if (e.detail) {  //Firefox滑轮事件
          value = e.detail
          value > 0 ? n = 1 : n = -1
        }
        let seep = 2
        let timer = setInterval(() => {
          if (seep >= 14) {
            clearInterval(timer)
            return
          }
          bus.$emit('changeTableScroll', seep * n)
          seep = seep + 2
        }, 20)
      }
      //给页面绑定滑轮滚动事件
      let ele = this.$refs['personal-overview']
      if (ele) {
        ele.addEventListener('DOMMouseScroll', scrollFunc, false);
        //滚动滑轮触发scrollFunc方法
        ele.onmousewheel = scrollFunc;
      }
    },
  }
}
</script>
<style lang="scss">
.personal-overview {
  display: flex;
  height: 100%;
}
</style>
